import I18NextHttpBackend from 'i18next-http-backend';
import React, { useContext } from 'react';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Routes, Route } from 'react-router-dom';
import { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { ThemeProvider } from '@volkswagen-onehub/components-core';
import VinDetails from './pages/VinDetails/VinDetails';
import StartPage from './pages/Startpage/StartPage';
import { FeatureServicesContext } from './use-feature-services';
import { LanguageCountryCode } from './context/language-country-code';

export function App({ localeService, authService, authServiceMarket }: Props): JSX.Element {
	const featureServices = useContext(FeatureServicesContext);
	let baseUrl = '';
	if (featureServices && featureServices['fa-content-service']) {
		baseUrl = featureServices['fa-content-service']!.content.baseAssetUrl;
	}
	// initialize translation module
	i18n.use(I18NextHttpBackend)
		.use(initReactI18next)
		.init({
			backend: {
				loadPath: `${baseUrl}/locales/${localeService.language}/translation.json`,
			},
			lng: localeService.language,
			fallbackLng: ['de', 'en', 'pl'],
			returnNull: false,
		});

	let language;
	if (!featureServices || !featureServices['fa-content-service'] || !featureServices['locale-service']) {
		language = 'de-DE';
	} else if (featureServices['fa-content-service']?.content.localeServiceCountryCodeOverride) {
		language = `${featureServices['locale-service']?.language}-${featureServices['fa-content-service']?.content.localeServiceCountryCodeOverride}`;
	} else {
		language = `${featureServices['locale-service']?.language}-${featureServices['locale-service']?.countryCode}`;
	}

	return (
		<LanguageCountryCode.Provider value={language}>
			<ThemeProvider theme="main">
				<Routes>
					<Route path="/" element={<StartPage />} />
					<Route path="/vin-details" element={<VinDetails authService={authService} authServiceMarket={authServiceMarket} />} />
					<Route path="/share/" element={<VinDetails authService={authService} authServiceMarket={authServiceMarket} />} />
					<Route path="/share/:token" element={<VinDetails authService={authService} authServiceMarket={authServiceMarket} />} />
				</Routes>
			</ThemeProvider>
		</LanguageCountryCode.Provider>
	);
}

interface Props {
	localeService: LocaleServiceV1;
	authService: IAuthServiceV2;
	authServiceMarket: IAuthServiceV2;
}
